import axios from 'axios'
import library from '../../../utils/Library'

export const helpUpdateTypeUserofOrganization = async (user) => {
  const TOKEN = sessionStorage.getItem('token')

  const URL =
    library.getBaseAPIUrl('organization') +
    '/updateUserOrganizationCorpEntities'

  return await axios({
    url: URL,
    method: 'POST',
    headers: {
      Authorization: `Bearer ${TOKEN}`
    },
    data: user
  })
}
